import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { SettingsApp, AJUSTES_DEFAULT } from 'src/app/models/ajustes-data.model';
import themes from 'devextreme/ui/themes';
import { LocalDataService } from '../almacenamiento/local-data.service';

@Injectable({
  providedIn: 'root'
})
export class AjustesProvider {
  public ajustes: SettingsApp = new SettingsApp(true, false);

  constructor(
    private platform: Platform,
    private localDataService: LocalDataService,
  ) { }

  // Add or remove the "dark" class based on if the media query matches
  toggleDarkTheme(shouldAdd) {
    document.body.classList.toggle('dark', shouldAdd);
    this.changeThemeDevextreme(shouldAdd);
  }

  changeThemeDevextreme(shouldAdd) {
    this.platform.ready().then(async () => {
      if (shouldAdd) {
        if (themes.current() !== 'material.blue.dark') {
          themes.current('material.blue.dark');
        }
      } else {
        if (themes.current() !== 'material.blue.light') {
          themes.current('material.blue.light');
        }
      }
    });
  }

  cargarAjustes(): Promise<boolean> {
    const promesa = new Promise<boolean>(async (resolve) => {



      // Consultar ajustes de la aplicación
      const ajustes = await this.localDataService.consultarLlave<SettingsApp>('ajustes');

      if (ajustes) {
        // console.log("Ajustes de Memoria Local");
        this.ajustes = ajustes;

        if (this.ajustes.blnDarkMode === undefined || this.ajustes.blnDarkMode == null) {
          const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');
          this.ajustes.blnDarkMode = prefersDark.matches;
          // Guarfar ajustes en memoria local
          await this.guardarAjustes();
        }

        // Validamos que la configuracion contenga la cadena del API de reportes
        if (this.ajustes.wmsApiReportesUrl === undefined || this.ajustes.wmsApiReportesUrl === '') {
          this.ajustes.wmsApiReportesUrl = AJUSTES_DEFAULT.WMS_API_REPORTES_URL;
          // Guarfar ajustes en memoria local
          await this.guardarAjustes();
        }

        if (this.ajustes.wmsApiOperacionUrl === undefined) {
          this.ajustes.wmsApiOperacionUrl = AJUSTES_DEFAULT.WMS_API_OPERACION_URL;
          // Guarfar ajustes en memoria local
          await this.guardarAjustes();
        }

        if (!!!this.ajustes.strHeaderColor) {
          this.getColorAmbiente();
        }


        this.toggleDarkTheme(this.ajustes.blnDarkMode);

      } else {

        // Revisamos el tipo de dispositivo para validar que configuraciones necesitamos habilitar po default
        let EsHadHeld = false;
        // Si no es core es un dispositivo movil
        if (this.platform.is('cordova')) {
          EsHadHeld = true;
        } else {
          // Es un navegador
          EsHadHeld = false;
        }


        this.ajustes = new SettingsApp(true, EsHadHeld);
        // Guarfar ajustes en memoria local
        await this.guardarAjustes();

        this.toggleDarkTheme(this.ajustes.blnDarkMode);
      }
      resolve(true);




    });

    return promesa;
  }

  guardarAjustes(): Promise<boolean> {
    return this.localDataService.guardarLlave('ajustes', this.ajustes);;
  }


  private getColorAmbiente() {

    switch (this.ajustes.wmsApiUrl) {
      case 'https://wms-api.grupo-logistics.com/prod/api/':
        this.ajustes.strHeaderColor = undefined;
        break;
      case 'https://wms-api-qa.grupo-logistics.com/qa/api/':
        this.ajustes.strHeaderColor = AJUSTES_DEFAULT.PLATFORM_COLOR_QA;
        break;
      case 'https://wms-api-test.grupo-logistics.com/Mtto/api/':
      case 'https://wms-api-test.grupo-logistics.com/Test/api/':
      case 'http://localhost:51635/api/':
        this.ajustes.strHeaderColor = AJUSTES_DEFAULT.PLATFORM_COLOR_TEST;
        break;
      default:
        this.ajustes.strHeaderColor = AJUSTES_DEFAULT.PLATFORM_COLOR_OTRO;
        break;
    }

  }

}
